import type { OAuthType, OAuthProvider } from './types';

export const LINKEDIN_SIGN_UP_PATH = '/users/social_signup/linkedin';
export const GOOGLE_SIGN_UP_PATH = '/users/social_signup/google_oauth2';

export const LINKEDIN_LOGIN_PATH = '/users/social_login/linkedin';
export const GOOGLE_LOGIN_PATH = '/users/social_login/google_oauth2';

export const OAUTH_URL: Record<OAuthProvider, Record<OAuthType, string>> = {
  linkedin: {
    login: LINKEDIN_LOGIN_PATH,
    signUp: LINKEDIN_SIGN_UP_PATH,
  },
  google: {
    login: GOOGLE_LOGIN_PATH,
    signUp: GOOGLE_SIGN_UP_PATH,
  },
};

export const NUMBER_OF_USERS = '250,000';
